import {
  GET_DELIVERY_MEN,
  GET_DELIVERY_MEN_SUCCESS,
  GET_DELIVERY_MEN_FAIL,
  GET_DELIVERY_MAN,
  GET_DELIVERY_MAN_SUCCESS,
  GET_DELIVERY_MAN_FAIL,
  CREATE_DELIVERY_MAN,
  CREATE_DELIVERY_MAN_SUCCESS,
  CREATE_DELIVERY_MAN_FAIL,
  UPDATE_DELIVERY_MAN,
  UPDATE_DELIVERY_MAN_SUCCESS,
  UPDATE_DELIVERY_MAN_FAIL,
  DELETE_DELIVERY_MAN,
  DELETE_DELIVERY_MAN_SUCCESS,
  DELETE_DELIVERY_MAN_FAIL,
} from "./actionTypes"

// Get all delivery men
export const getDeliveryMen = (history) => ({
  type: GET_DELIVERY_MEN,
  payload: { history },
})

// Get delivery man by ID
export const getDeliveryMan = (deliveryManId, history) => ({
  type: GET_DELIVERY_MAN,
  payload: { deliveryManId, history },
})

// Create new delivery man
export const createDeliveryMan = (deliveryMan, history) => ({
  type: CREATE_DELIVERY_MAN,
  payload: { deliveryMan, history },
})

// Update delivery man
export const updateDeliveryMan = (deliveryManId, deliveryMan, history) => ({
  type: UPDATE_DELIVERY_MAN,
  payload: { deliveryManId, deliveryMan, history },
})

// Delete delivery man
export const deleteDeliveryMan = (deliveryManId, history) => ({
  type: DELETE_DELIVERY_MAN,
  payload: { deliveryManId, history },
})
